<template>
  <div>
    <Header />
    <MobileMenu
      class="min-[900px]:hidden [&_button]:right-[11vw] [&_button]:top-[12vw] min-[475px]:[&_button]:right-[13vw]"
    />
    <div class="h-full w-full overflow-x-hidden bg-avu-gray">
      <slot />
    </div>
    <Footer />
  </div>
</template>
